import React, { useEffect, useState } from "react";
import { connect, Form, Formik, useFormikContext } from 'formik';
import API from 'util/Api';
import * as Yup from "yup";
import _ from "lodash";
import { Box, Button, Typography } from '@material-ui/core';
import FormField from "components/FormField";
import SnackBar from 'components/SnackBar';
import CardBox from "components/CardBox"; 
import ContainerHeader from "components/ContainerHeader";
import ProgressBar from "components/Progress/LinearProgress";
import SimpleTable from "components/ActionsTable/SimpleTable";
import {getFieldValues} from '../../../../../util/GenericFunc'
import PopUpDialog from 'components/PopUpDialog';


const EZField = connect((props) =>{
    let field = _.cloneDeep(props.field)
    const values = props.formik.values;
    const [previousValues, setPreviousValues] = useState(props.formik.values);

    useEffect(()=>{
        if(props.currentQRCode){  
            let isSame = _.isEqual(props.currentQRCode,props.formik.values)
            if(!isSame){
                props.formik.setValues(props.currentQRCode)                                
            }
        }                
    },[props.currentQRCode]);


    useEffect(() => {
        if((previousValues.location_type !== props.formik.values.location_type) && !props.currentQRCode){
            setPreviousValues(props.formik.values)
            props.formik.setFieldValue('location_id', null);
        }
    },[props.formik.values.location_type]);

    if (field.dependency) {
        let fieldValue = values[field.dependency] || null;

        if(fieldValue && field.dependencyValue.includes(fieldValue)) {
            return(<div className="col-md-3 col-12"  key={`field-${props.field.key}`}>
                <FormField
                    field={{
                        ...field,
                        ...{name: field.key},
                        ...{options: props.locations[fieldValue]}
                    }}
                />
            </div>);
        } else {
            if(values[field.key] !== null){
                props.formik.setFieldValue(field.key, null);
            }
            // return null;
        }
    }

    return(<div className="col-md-3 col-12" key={`field-${props.field.key}`}>
        <FormField
            field={{
                ...field,
                ...{name:field.key}                
            }}
        />
    </div>);
});

const FilterForm = connect((props) => {
    console.log('FilterForm-props', props);
    const { isSubmitting } = useFormikContext();

    return (
        <div className="row">
            <CardBox styleName="col-12">
                <Form>
                    {/* FIRST ROW */}
                    <div className="row">
                        {Object.values(props.fields)?.map((field) => (
                            <EZField 
                                field={{
                                    ...field
                                }}
                                {...(field.key =='location_id' && {locations: props.locations})}
                                {...{currentQRCode: props.currentQRCode}}
                            />
                        ))}
                    </div>
                    {/* BUTTONS */}
                    <div className="row mt-2">
                        <div className="col-lg-6 col-sm-12 col-12">
                            <Box mt="20px">
                                <Box mr="10px" display="inline">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        mr="5px"
                                        type="submit"
                                        disabled={isSubmitting}
                                    >
                                        {` Submit `}
                                    </Button>
                                </Box>
                                <Box mr="10px" display="inline">
                                    <Button variant="outlined" color="secondary" type="reset">
                                        Reset
                                    </Button>
                                </Box>
                            </Box>
                        </div>
                    </div>
                </Form>
            </CardBox>
        </div>
    );
});

const RazorpayQRDetails = (props) => {
    const [config, setConfig] = useState();
    const [initialValues, setInitialValues] = useState();
    const [locations, setLocations] = useState([]);
    const [currentQRCode, setCurrentQRCode] = useState(null)
    const [selectedQR, setSelectedQR] = useState({});
    const [razorpayQR, setRazorpayQR] = useState();
    const [loading, setLoading] = useState(false);
    const [snackBar, setSnackBar] = useState({ open: false, message: '', type: 'error' });

    const [dialog, setDialog] = useState({
        open:false,
        dialogContent:'',
        dialogAgreeBtnTxt:'',
        dialogDisAgreeBtnTxt:'',
        dialogHeader:'',
        dialogType:'',
        isBtnDisabled:false
    });
    
    
    const validations = Yup.object().shape({
        location_type: Yup.string().required("Required"),
        location_id: Yup.object().required("Required"),
        qr_code_id: Yup.string().required("Required"),
    });

    useEffect(() => {
        API.get("razorpayQRcodeDetails")
        .then((res) => {
            console.log("razorpar_QRs", res)
            const resConfig = res.data.data.config;
            const values = getFieldValues(Object.values(resConfig.fields));
            setInitialValues(values);
            setConfig(resConfig);
            setRazorpayQR(res.data.data.qrCodes);
            setLocations(res.data.data.locations);
        })
        .catch((err) => {
            console.log("catch", err);
        })
    },[]);

    const handleSubmit = (data, form) => {
        console.log("getFieldValues_____ form", data);
        setLoading(true);
        form.setSubmitting(true);

        if(data.id){
            API.put("razorpayQRcode", JSON.stringify(data))
            .then((res) => {
                console.log("razorpar_QRs", res, res.data.data.qrCodes)
                setRazorpayQR(res.data.data.qrCodes);
                setLoading(false);
                form.resetForm();
                form.setSubmitting(false);
                setSnackBar({open:true, message:"QR code updated successfully.", type:'success'});
            })
            .catch((err) => {
                console.log("catch", err);
                setLoading(false);
                form.setSubmitting(false);
                setSnackBar({open:true, message:err.response.data.msg, type:'error'});
            })

        } else{
            API.post("razorpayQRcode", JSON.stringify(data))
            .then((res) => {
                console.log("razorpar_QRs", res, res.data.data.qrCodes)
                setRazorpayQR(res.data.data.qrCodes);
                setLoading(false);
                form.resetForm();
                form.setSubmitting(false);
                setSnackBar({open:true, message:"QR code saved successfully.", type:'success'});
            })
            .catch((err) => {
                console.log("catch", err);
                setLoading(false);
                form.setSubmitting(false);
                setSnackBar({open:true, message:err.response.data.msg, type:'error'});
            })
        }

        form.setSubmitting(false);
    }

    const handReset = () =>{
        setCurrentQRCode(null);
    }

    const updateQR = (qr) => {
        console.log("getFieldValues_____ qr_code", qr);
        const currentQRCode = {id: qr.id, location_id: {title: qr.location_name, value: qr.location_id_hidden}, location_type: qr.location_type, qr_code_id: qr.qr_code_id}
        setCurrentQRCode(currentQRCode);
        
        // scroll to top 
        document.body.style.height = 'auto';        
        setTimeout(function(){
            document.body.style.height = '100%';
        },50)
    }

    const updateStatus = (qr_id,checked,cb) => {
        var text = checked ? 'Are you sure you want to activate QR code?' : 'Are you sure you want to deactivate QR code?'
        var header = checked ? 'Activate QR Code' : 'Deactivate QR Code'
        console.log('onEnable params__',qr_id,checked);
        console.log('onEnable params__', razorpayQR);
        const QRcode = razorpayQR.tbody.find(qr => qr.id === qr_id);
        setSelectedQR({...QRcode, active:checked});
        setDialog(prevState => ({...prevState, open:true, dialogAgreeBtnTxt:'Confirm', dialogDisAgreeBtnTxt:'Cancel', dialogContent:text, dialogHeader:header, callback:cb}))
    }

    const confirmUpdateStatus = () => {
        console.log("updateClientSubscription", selectedQR);
        setDialog(prevState => ({...prevState, isBtnDisabled:true}));
        API.put("razorpayQRcodeStatus", JSON.stringify(selectedQR)).then((res) => {
            dialog.callback(selectedQR.active);
            setDialog(prevState => ({...prevState, open:false, dialogAgreeBtnTxt:'', dialogDisAgreeBtnTxt:'', dialogContent:'', dialogHeader:'', isBtnDisabled:false, callback:null}));
            setSnackBar({open:true, message:`Razorpay QR ${selectedQR.qr_code_id} ${selectedQR.active == true ? 'Activated' : 'Deactivated'} successfully`, type:'success'});
            setSelectedQR({});
            setTimeout(function(){
                handleConfirmDialogClose()
            },1000);
        }).catch((err) => {
            setSnackBar({open:false, message:err.response.data.msg, type:'error'});
            console.log("post config error ", err);
        });
    } 

    const handleConfirmDialogClose = () => {
        setDialog(prevState => ({...prevState, open:false,dialogAgreeBtnTxt:'',dialogDisAgreeBtnTxt:'',dialogContent:'',dialogHeader:'',isBtnDisabled:false,callback:null}));
        setSelectedQR({});
    }


    return(
        config &&
         initialValues &&
        <>
            <ContainerHeader title={config.title} match={props.match} />
            <Formik
                onSubmit={handleSubmit}
                onReset={handReset}
                initialValues={initialValues}
                validationSchema={validations}
            >
                <FilterForm fields={config.fields} currentQRCode={currentQRCode} locations={locations} />
            </Formik>
            <ProgressBar isProgress={loading}/>
            {razorpayQR &&
                <div className="row">
                    <CardBox styleName="col-12"
                        headerOutside
                        heading={
                            <React.Fragment>
                                {razorpayQR.title}
                            </React.Fragment>
                        }
                    >
                        <SimpleTable
                            type={'RazorpayQR'}
                            table={razorpayQR}
                            onUpdate={updateQR}
                            updateStatus={updateStatus}
                        />
                    </CardBox>
                </div>
            }
             <PopUpDialog
                open={dialog.open}
                header={dialog.dialogHeader}
                content ={dialog.dialogContent}
                agreeBtnTxt ={dialog.dialogAgreeBtnTxt}
                disAgreeBtnTxt={dialog.dialogDisAgreeBtnTxt}
                isBtnDisabled={dialog.isBtnDisabled}
                agreeClicked ={confirmUpdateStatus}
                handleDialogClose={handleConfirmDialogClose}
            />
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
        </>
    )

}

export default RazorpayQRDetails;